export default __webpack_public_path__ + "54421ad90c2b38ee13a95cf4bd51305c.png";